'use client'

import { TableIcon } from 'lucide-react'
import { useEditorContext } from '@/components/ui/editor'
import { Button } from '@/components/ui/button'

const Table = () => {
  const { editor, sourceMode } = useEditorContext()

  const insertTable = () => {
    editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()
  }

  return (
    <Button
      type="button"
      size="sm"
      variant="ghost"
      onClick={insertTable}
      title="Insert Table"
      disabled={sourceMode}
      tabIndex={-1}>
      <TableIcon className="h-4 w-4" />
    </Button>
  )
}

export default Table
